<script setup lang="ts">
import { useNavbarDropdown } from '~/composables/useNavbarDropdown';

const { arrivedState } = useWindowScroll();
const isScrolled = computed(() => {
  return !arrivedState.top;
});

const navbar = useTemplateRef('navbar_ref');
const {
  open: dropdownOpen,
  type: dropdownType,
  toggle: toggleDropdown,
} = useNavbarDropdown(250);

const burgerOpen = ref(false);

watch(
  () => useRoute().path,
  () => {
    toggleDropdown(false);
    burgerOpen.value = false;
  },
);

const { height: navbarHeight } = useElementSize(navbar, undefined, {
  box: 'border-box',
});
watch(navbarHeight, (v) => {
  document.documentElement.style.setProperty('--navbar-height', `${v}px`);
});

const linkReservation = 'Rezervace';
</script>

<template>
  <nav ref="navbar_ref" class="bg-client-black fixed top-0 left-0 z-10 w-full">
    <PageContainerAlignment
      :class="
        isScrolled
          ? 'py-r2 shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1)]'
          : 'py-r4 lg:pt-r6 lg:pb-r4'
      "
      class="flex w-full items-center justify-between transition-[padding,box-shadow] duration-300"
    >
      <AppLink type="custom" to="/" :opts="{}">
        <AppLogo theme="dark" size="md" />
      </AppLink>
      <NavbarBurgerButton
        :open="burgerOpen"
        class="xl:hidden"
        @click="burgerOpen = !burgerOpen"
      />
      <NavbarLinkContainer
        :dropdown-type
        class="max-xl:hidden"
        @dropdown-open="toggleDropdown(true, $event)"
        @dropdown-close="toggleDropdown(false)"
      />
      <AppLink
        type="button"
        to="https://okgym.clubspire.cz/"
        :opts="{ link: { external: true } }"
        class="max-xl:hidden"
      >
        {{ linkReservation }}
      </AppLink>
    </PageContainerAlignment>
    <NavbarDropdown
      :reference="navbar"
      :open="dropdownOpen"
      :type="dropdownType"
      class="max-xl:hidden"
      @close="toggleDropdown(false)"
    />
    <NavbarBurger
      :reference="navbar"
      :open="burgerOpen"
      class="xl:hidden"
      @close="burgerOpen = false"
    />
  </nav>
</template>
